import { Temporal } from '@js-temporal/polyfill'

/** Short format for debug/compact UI: dd/MM/yyyy HH:mm (UTC). */
export const CAMPAIGN_START_FORMAT_SHORT = 'dd/MM/yyyy HH:mm'

/** Long format for waiting screen: dd/MM/yyyy 'às' HH:mm (UTC). */
export const CAMPAIGN_START_FORMAT_LONG = 'dd/MM/yyyy \'às\' HH:mm'

/**
 * Formats a campaign start/end date (ISO string, Temporal.Instant, or null) for display in UTC.
 * Returns empty string for null/invalid.
 */
export function formatCampaignStartDate(
  startDate: string | Temporal.Instant | Date | null | undefined,
  pattern: string = CAMPAIGN_START_FORMAT_SHORT
): string {
  if (startDate == null) { return '' }
  let instant: Temporal.Instant
  try {
    if (typeof startDate === 'string') {
      const iso = startDate.length === 10 && !startDate.includes('T')
        ? `${startDate}T00:00:00.000Z`
        : startDate
      instant = Temporal.Instant.from(iso)
    }
    else if (startDate instanceof Temporal.Instant) {
      instant = startDate
    }
    else {
      instant = Temporal.Instant.fromEpochMilliseconds(startDate.getTime())
    }
  }
  catch {
    return String(startDate)
  }
  const zoned = instant.toZonedDateTimeISO('UTC')
  if (pattern === CAMPAIGN_START_FORMAT_SHORT) {
    return `${String(zoned.day).padStart(2, '0')}/${String(zoned.month).padStart(2, '0')}/${zoned.year} ${String(zoned.hour).padStart(2, '0')}:${String(zoned.minute).padStart(2, '0')}`
  }
  if (pattern === CAMPAIGN_START_FORMAT_LONG) {
    return `${String(zoned.day).padStart(2, '0')}/${String(zoned.month).padStart(2, '0')}/${zoned.year} às ${String(zoned.hour).padStart(2, '0')}:${String(zoned.minute).padStart(2, '0')}`
  }
  const pad = (n: number) => String(n).padStart(2, '0')
  return pattern
    .replace('dd', pad(zoned.day))
    .replace('MM', pad(zoned.month))
    .replace('yyyy', String(zoned.year))
    .replace('HH', pad(zoned.hour))
    .replace('mm', pad(zoned.minute))
    .replace('ss', pad(zoned.second))
}
